// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Pace from 'pace'
import Vuetify from 'vuetify'
import Esqueleto from './Esqueleto'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'

import axios from 'axios'

Pace.start({
	ajax: {
         trackMethods: ['GET', 'POST']
   }
});

Vue.use(Vuetify)

Vue.config.productionTip = false

/*
var protocol = window.location.protocol
var hostname = window.location.hostname;
*/

var protocol = 'https:';
var hostname = 'inmuebles.9dejulio.com';
var apiurl = protocol + '//' + hostname + '/api/v1/'
var siteurl = protocol + '//'+ hostname +'/'

Vue.prototype.$apiUrl = apiurl
Vue.prototype.$siteUrl = siteurl
Vue.prototype.$axios = axios


Vue.use(VueAnalytics, {
  id: () => axios.get( apiurl + 'empresa/item?url=' + window.location.hostname).then(function (response) {
    return response.data.item.gaid
  })
  .catch(function (error) {
    // handle error
    return "UA-300573-9";
  }),
  debug: {
    enabled: false
  },
  router
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<Esqueleto/>',
  store,
  components: { Esqueleto }
})



// WEBPACK FOOTER //
// ./src/main.js